export default "__VITE_ASSET__58b8cc2e__"